module.exports = __webpack_public_path__ + "img/acTwo.948ee6df.jpg";